import imageCompression from 'browser-image-compression';

/**
 * Compress an image file without cropping
 * @param {File} file - The image file to compress
 * @param {Object} options - Compression options
 * @returns {Promise<File>} - Compressed image file
 */
export const compressImage = async (file, options = {}) => {
  const defaultOptions = {
    maxSizeMB: 0.6, // 600KB default
    maxWidthOrHeight: 1600,
    useWebWorker: true,
    fileType: 'image/jpeg',
    initialQuality: 0.85,
    alwaysKeepResolution: false,
    preserveExif: false
  };

  const compressionOptions = { ...defaultOptions, ...options };

  try {
    const compressedBlob = await imageCompression(file, compressionOptions);

    // Convert blob to File with proper name and type
    const originalName = file.name || 'image.jpg';
    const fileName = originalName.replace(/\.[^/.]+$/, '') + '.jpg'; // Replace extension with .jpg

    const compressedFile = new File([compressedBlob], fileName, {
      type: 'image/jpeg',
      lastModified: Date.now()
    });

    return compressedFile;
  } catch (error) {
    console.error('Error compressing image:', error);
    throw error;
  }
};

/**
 * Compression presets for different image types
 */
export const COMPRESSION_PRESETS = {
  post: {
    maxSizeMB: 0.6,
    maxWidthOrHeight: 1600,
    initialQuality: 0.85
  },
  project: {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 1200,
    initialQuality: 0.85
  },
  companyPost: {
    maxSizeMB: 0.6,
    maxWidthOrHeight: 1600,
    initialQuality: 0.85
  }
};
